import { baseUrl } from '../../config/appsettings';

const PublisherApiService = {
    get: async () => {
      try {
        const apiEndpoint = `${baseUrl}Publisher/Get`;
        const response = await fetch(apiEndpoint, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
      }
    },
    getAllApproved: async () => {
      try {
        const apiEndpoint = `${baseUrl}Publisher/GetAllApproved`;
        const response = await fetch(apiEndpoint, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
      }
    },

    getById: async (id) => {
        try {
          const apiEndpoint = `${baseUrl}Publisher/Get/${id}`;
    
          const response = await fetch(apiEndpoint, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });
    
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error occurred');
          }
    
          const result = await response.json(); // Parse the JSON response
          return result; // Return response data on success
        } catch (error) {
          console.error('Error:', error);
          throw new Error('Network error');
        }
      },

      updateInvoice: async (id) => {
        try {
          const apiEndpoint = `${baseUrl}Publisher/UpdateInvoice/${id}`;
    
          const response = await fetch(apiEndpoint, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });
    
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error occurred');
          }
    
          const result = await response.json(); // Parse the JSON response
          return result; // Return response data on success
        } catch (error) {
          console.error('Error:', error);
          throw new Error('Network error');
        }
      },

      ApprovePublisher: async (id) => {
        try {
          const apiEndpoint = `${baseUrl}Publisher/ApprovePublisher?publisherId=${id}`;
    
          const response = await fetch(apiEndpoint, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
            },
          });
    
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error occurred');
          }
    
          const result = await response.json(); // Parse the JSON response
          return result; // Return response data on success
        } catch (error) {
          console.error('Error:', error);
          throw new Error('Network error');
        }
      },
      DeletePublisher: async (id) => {
        try {
          const apiEndpoint = `${baseUrl}Publisher/Delete/${id}`;
          const response = await fetch(apiEndpoint, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });
    
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error occurred');
          }
    
          const result = await response.json(); // Parse the JSON response
          return result; // Return response data on success
        } catch (error) {
          console.error('Error:', error);
          throw new Error('Network error');
        }
      },
      AssignAdsCode : async (data) => {
        try {
          const apiEndpoint = `${baseUrl}Publisher/AssignedAdscode`; // Complete URL for the signup endpoint
    
          const response = await fetch(apiEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data), // Convert data to JSON
          });
          
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error occurred');
          }
    
          const result = await response.json(); // Parse the JSON response
          return result; // Return response data on success
        } catch (error) {
          console.error('Add Website error:', error);
          throw new Error('Network error');
        }
      },
  };
  
  export default PublisherApiService;
  